module.exports = __webpack_public_path__ + "img/6.1b888236.png";